import {ref} from 'vue'
import {defineStore} from 'pinia'
import {useCrud} from "@/composables/CrudAxios";
import {useRoute} from "vue-router";
import {useToast} from "primevue/usetoast";
import type {getDataResponse, reservation, Store, User} from "@/types/types";
import router from "@/router";

export const useUserStore = defineStore('user', () => {
    const crud = useCrud();
    const route = useRoute();
    const toast = useToast();

    const user = ref({} as User);
    const store = ref({} as Store);
    const storeId = ref(route.query.store);
    const session = ref<any>(localStorage.getItem(`${storeId.value}_guest`) ? JSON.parse(localStorage.getItem(`${storeId.value}_guest`) as string) : null);


    async function makeReservation(data: reservation) {
        const {postFormAsync} = useCrud();
        // If this is an event flow (eventid present), call the event-specific endpoint
        const isEvent = (data as any).eventid || (data as any).optionid || (data as any).quantity;
        const url = isEvent
            ? `/extern/table/makeeventreservation/?store=${storeId.value}`
            : `/extern/table/makereservation/?store=${storeId.value}`;

        const response = await postFormAsync(url, data);
        const resData = (response && response.status) ? response : { status: { success: false, message: 'Unbekannte Antwort' } } as any;
        toast.removeAllGroups();
        toast.add({
            severity: resData?.status?.success ? 'success' : 'error',
            summary: resData?.status?.success ? 'Reservierung erfolgreich' : 'Fehler bei Reservierung:',
            detail: resData?.status?.success ? '' : resData?.status?.message,
            life: 5000
        });

        return response;
    }


    const loginUser = async (values: { email: string, pw: string }) => {
        try {
            const response = await crud.postAsync("/extern/customerSso/login", {
                email: values.email,
                password: values.pw,
                storeId: storeId.value
            });
            if (response && response.success) {
                session.value = response.sessionHash;
                localStorage.setItem(`${storeId.value}_guest`, JSON.stringify(session.value));
            }
            toast.add({
                severity: response && response.success ? 'success' : 'error', summary: response && response.success ?
                    'Erfolgreich eingeloggt' : 'Fehler beim Login:', detail: response && response.success ? '' : response.message, life: 5000
            });
            return response;
        } catch (error: any) {
            toast.add({severity: 'error', summary: error.status, detail: error.statusText, life: 5000});
            console.log(error);
        }
    }

    const logoutUser = async () => {
        try {
            await crud.postAsync("/extern/customer-sso/logout", {sessionHash: session.value});
            localStorage.removeItem(`${storeId.value}_guest`);

            user.value = {} as User;
            session.value = null;
            await router.push(`/?store=${storeId.value}`);
        } catch (error: any) {
            toast.add({severity: 'error', summary: error.status, detail: error.statusText, life: 5000});
            console.log(error);
        }
    }

    const getUserData = async () => {
        try {
            const response = await crud.postAsync("/extern/customer-sso/getData", {sessionHash: session.value});
            if (response && response.success) {
                const responseData: getDataResponse = response;
                user.value = responseData.data.customer;
                store.value = responseData.data.store;
            }
        } catch (error: any) {
            toast.add({severity: 'error', summary: error.status, detail: error.statusText, life: 5000});
            console.log(error);
        }
    }

    return {loginUser, logoutUser, makeReservation, getUserData, user, session, storeId}
})
